import React, { useState, useEffect } from "react";
import { Button, makeStyles, Table, TableContainer } from "@material-ui/core";
import { connect } from "react-redux";

import styles from "../../../styles/global-styles";
import StatelessTableHeadGlobalDistribution from "../../stateless/headTables/StatelessTableHeadGlobalDistribution";
import { actions } from "../../../redux/actions/alert";
import HeaderDistributionByCodeBar from "./HeaderDistributionByCodeBar";
import SiteSelect from "../../shared/selects/SiteSelect";
import DistributionListByCodeBar from "./DistributionListByCodeBar";
import UpdatePriceForDistribution from "../modals/UpdatePriceForDistribution";
import { AccesoryService } from "../../../services/accesory.service";
import UsersBySiteSelect from "../../shared/selects/UsersBySiteSelect";
import { ProductService } from "../../../services/product.service";
import { validateOriginStoreAndDistribution } from "../inventory/utils.inventory";
import { DistributionService } from "../../../services/distribution.service";
import { NotificationService } from "../../../services/notification.service";
import { AuthService } from "../../../services/auth.service";
import BackDrop from "../../shared/backdrop/Backdrop";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  chip: styles.chip,
  backgroundIcon: styles.backgroundIcon,
  redBackgroundIcon: styles.redBackgroundIcon,
  deleteLink: styles.deleteLinkWithoutFontS,
  detailsLink: styles.detailsLink,
  optionsContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: 600,
  },
}));

const DistributionByCodeBar = ({ detailAlert, addAlert }) => {
  const classes = useStyles();

  const [accesoriesIdArray, setaccesoriesIdArray] = useState([]);
  const [productsForDistribution, setProductsForDistribution] = useState([]);
  const [priceDialog, setPriceDialog] = useState({});
  const [distributeOrder, setDistributeOrder] = useState({});
  const [distributionCompleted, setDistributionCompleted] = useState(true);

  useEffect(() => {
    (async function () {
      try {
        const { siteId, id } = await AuthService.currentUserValue;
        if (!!siteId && !!id) {
          setDistributeOrder({
            ...distributeOrder,
            personDeliverId: id,
            statusDistributionId: 1,
            /** Origin site ALMACEN */
            siteId: 1,
          });
        } else AuthService.logout();
      } catch (error) {
        if (error.status === 404) {
          // TODO redirect login create logout service
          setTimeout(() => {
            console.log("user", error.msgs);
            AuthService.logout();
          }, 3000);
        }
        console.log("error", error);
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs, time: 2400 });
      }
    })();
  }, []);

  const productsPriceDifferent = (productsByBarCode) => {
    const price = productsByBarCode[0].accesory.price;
    return !productsByBarCode.some((item) => item.accesory.price !== price)
      ? price
      : "Precios diferentes";
  };

  const productAlreadyAdded = (prodsAvailable) => {
    return productsForDistribution.some(
      (accesory) => accesory.barCode === prodsAvailable[0].accesory.barCode
    );
  };

  const handleProductsFiltered = (prodsAvailable) => {
    if (!productAlreadyAdded(prodsAvailable)) {
      setProductsForDistribution([
        ...productsForDistribution,
        {
          availability: prodsAvailable.length,
          brand: prodsAvailable[0].accesory.brand,
          model: prodsAvailable[0].accesory.model,
          subcategory: prodsAvailable[0].accesory.subcategory_type.name,
          barCode: prodsAvailable[0].accesory.barCode,
          price: productsPriceDifferent(prodsAvailable),
        },
      ]);

      //Filter by accesories Id
      const accesoriesArray = prodsAvailable.map(
        (product) => product.accesoryId
      );
      //Filter by products Id
      const idProductsArray = prodsAvailable.map((product) => product.id);
      setaccesoriesIdArray([
        ...accesoriesIdArray,
        {
          accesories: accesoriesArray,
          barCode: prodsAvailable[0].accesory.barCode,
          productsId: idProductsArray,
        },
      ]);
    }
  };

  const handleDeleteProduct = (barCode) => {
    const copyProductsArray = [...productsForDistribution];
    const copyidAccesoriesList = [...accesoriesIdArray];

    const newProductList = copyProductsArray.filter(
      (product) => product.barCode !== barCode
    );
    const newAccesoriesIdtList = copyidAccesoriesList.filter(
      (product) => product.barCode !== barCode
    );

    console.log("newProductList", newProductList);
    console.log("newAccesoriesIdtList", newAccesoriesIdtList);
    if (!newProductList.length) {
      setDistributeOrder({});
    }
    setProductsForDistribution(newProductList);
    setaccesoriesIdArray(newAccesoriesIdtList);
  };

  const handleUpdateProductPrice = (barCode, quantityForDistribution) => {
    console.log("quantityForDistribution", quantityForDistribution);
    if (quantityForDistribution)
      setPriceDialog({
        open: true,
        barCode,
        quantity: quantityForDistribution,
      });
    else {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: "Indicar la cantidad de accesorios a distribuir",
        time: 3000,
      });
    }
  };

  const updatePriceForAccesory = async (
    newPrice,
    accesoryBarCode,
    quantity
  ) => {
    const productFiltered = accesoriesIdArray.filter(
      (product) => product.barCode === accesoryBarCode.toString()
    );
    console.log("productFiltered", productFiltered);
    const productsForUpdate = productFiltered[0].accesories.slice(0, quantity);
    console.log("productsForUpdate", productsForUpdate);
    try {
      const { status } = await AccesoryService.bulkUpdateAccesoryPrices(
        productsForUpdate,
        {
          price: newPrice,
        }
      );
      addAlert({ showAlert: true });
      if (status === 201) {
        detailAlert({
          severity: "success",
          message:
            "Precio de accesorios para distribuir actualizado exitosamente",
          time: 3000,
        });
      } else {
        const updateError = {
          message: "Error al actualizar los accesorios",
        };
        throw updateError;
      }
    } catch (error) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.message
          ? error.message
          : "Error al actualizar el precio de los productos para distribuir",
        time: 3000,
      });
    }
  };

  const modifiedQuantityForDistribution = (barCode, operation) => {
    const copyList = [...productsForDistribution];

    if (operation === "add") {
      copyList.forEach((product, i) => {
        if (product.barCode === barCode) {
          if (copyList[i].availability > 0) {
            copyList[i] = {
              ...copyList[i],
              distribution: copyList[i].distribution + 1 || 1,
              availability: copyList[i].availability - 1,
            };
          }
        }
      });
    } else {
      copyList.forEach((product, i) => {
        if (product.barCode === barCode) {
          copyList[i] = {
            ...copyList[i],
            distribution:
              copyList[i].distribution > 0 ? copyList[i].distribution - 1 : 0,
            availability:
              copyList[i].distribution > 0
                ? copyList[i].availability + 1
                : copyList[i].availability,
          };

          if (copyList[i].distribution) {
            console.log("SIGUE exsite distribution");
          }

          if (copyList.length === 1 && !copyList[i].distribution) {
            console.log("YA NO hay nada que distribuir");
            const copy = { ...distributeOrder };
            delete copy.userId;
            setDistributeOrder(copy);
          }
        }
      });
    }

    setProductsForDistribution(copyList);
  };

  const handleOptionSelected = (__, value) => {
    if (
      distributeOrder.siteDestinationId !== undefined &&
      distributeOrder.siteDestinationId !== value
    ) {
      const copy = { ...distributeOrder };
      delete copy.userId;
      setDistributeOrder({ ...copy, siteDestinationId: value });
    } else if (value) {
      setDistributeOrder({
        ...distributeOrder,
        siteDestinationId: value,
      });
    }
  };

  const handleUserSiteSelect = (key, value) => {
    if (key && value) {
      setDistributeOrder({
        ...distributeOrder,
        userId: value,
      });
    }
  };

  const submitProductDistribution = async () => {
    setDistributionCompleted(false);

    /** Validate distribution origin id 1 = 'Almacen' */
    let productsIdByDistribution = [];
    let accesoriesIdByDistribution = [];

    console.log("START ==============");

    productsForDistribution.forEach((item, index) => {
      const productsIdSlice = accesoriesIdArray[index].productsId.slice(
        0,
        item.distribution
      );
      const accesoriesIdSlice = accesoriesIdArray[index].accesories.slice(
        0,
        item.distribution
      );
      productsIdByDistribution = [
        ...productsIdByDistribution,
        ...productsIdSlice,
      ];
      accesoriesIdByDistribution = [
        ...accesoriesIdByDistribution,
        ...accesoriesIdSlice,
      ];
    });
    console.log("productsIdByDistribution", productsIdByDistribution);
    console.log("accesoriesIdByDistribution", accesoriesIdByDistribution);

    console.log("END ==============");

    try {
      const { data } = await ProductService.getAllProductsInRange({
        idProductArray: productsIdByDistribution,
      });
      console.log("getAllProductsInRange", data);
      const validateOrigin = validateOriginStoreAndDistribution(
        data,
        "accesory"
      );
      if (!validateOrigin) {
        setTimeout(() => window.location.reload(), 2800);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "info",
          message:
            "Se han hecho movimientos en los accesorios seleccionados, volver a repetir la operación",
          time: 3000,
        });
        setDistributionCompleted(true);
        return;
      }

      const productsWithDistributionInfo = [];
      for (let index = 0; index < productsIdByDistribution.length; index++) {
        await productsWithDistributionInfo.push({
          productId: productsIdByDistribution[index],
          ...distributeOrder,
        });
      }
      console.log("productsForDistribution", productsWithDistributionInfo);

      const resultDistribution =
        await DistributionService.createBulkDistribution(
          productsWithDistributionInfo
        );
      console.log("result Distribution", resultDistribution.data.length);
      const distributionsId = resultDistribution.data.map((item) => item.id);
      console.log("distributionsId======", distributionsId);

      const { userId, siteDestinationId } = productsWithDistributionInfo[0];
      const notificationObject = {
        distributionsId,
        userId,
        siteId: siteDestinationId,
        open: false,
      };

      const response = await NotificationService.createNotification(
        notificationObject
      );
      const { status } = await AccesoryService.updateAvailableStatus(
        accesoriesIdByDistribution
      );
      console.log("status AccesoriesAvailableUpdated", response.status);

      if (status === 201) {
        setTimeout(() => window.location.reload(), 2800);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "success",
          message: "Distribución realizada con éxito",
          time: 2300,
        });
        setDistributionCompleted(true);
      }
    } catch (error) {
      console.log("error submitProductDistribution", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error || "Error al realizar la distribución global",
        time: 3000,
      });
      setDistributionCompleted(true);
    }
  };

  return (
    <>
      <HeaderDistributionByCodeBar productsByBarCode={handleProductsFiltered} />
      <TableContainer>
        <Table className={classes.table} aria-label="customized table">
          {productsForDistribution.length > 0 && (
            <>
              <StatelessTableHeadGlobalDistribution />

              <DistributionListByCodeBar
                productsForDistribution={productsForDistribution}
                modifiedDistribution={modifiedQuantityForDistribution}
                deleteProductFromList={handleDeleteProduct}
                updateAccesoryPrice={handleUpdateProductPrice}
              />
            </>
          )}
        </Table>
      </TableContainer>

      {productsForDistribution.length > 0 &&
        productsForDistribution.some((product) => product.distribution) && (
          <div className={classes.optionsContainer}>
            <SiteSelect
              title="Seleccionar sucursal"
              site={handleOptionSelected}
              removeStore
            />

            <UsersBySiteSelect
              user={handleUserSiteSelect}
              siteSelected={distributeOrder.siteDestinationId}
            />
          </div>
        )}

      {distributeOrder.userId && (
        <div style={{ marginTop: 15 }}>
          <Button
            className={classes.rightButton}
            variant="contained"
            color="primary"
            onClick={submitProductDistribution}
          >
            Distribuir
          </Button>
        </div>
      )}

      {priceDialog.open && (
        <UpdatePriceForDistribution
          open={priceDialog.open}
          onClose={() => setPriceDialog({})}
          barCode={priceDialog.barCode}
          updatePrice={updatePriceForAccesory}
          quantity={priceDialog.quantity}
        />
      )}

      {!distributionCompleted && (
        <BackDrop
          style={{
            zIndex: 1,
            color: "#1C2668",
          }}
          isOpen={!distributionCompleted}
        />
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(DistributionByCodeBar);
